import { TextField } from "@mui/material";
import React from "react";

export default function TextFieldComponentV2Mobile(props) {
  const handleChange = (event) => {
    props.onChange(event.target.value);
  };
  return (
    <div style={{ width: "100%" }}>
      <div
        style={{
          color: "#a0a0a0",
          fontWeight: "500",
          fontSize: "12px",
          textTransform: "uppercase",
        }}
      >
        {props.title}
      </div>
      <TextField
        style={{
          width: "100%",
          background: "#f3f3f3",
          marginTop: 5,
        }}
        multiline
        rows={4}
        value={props.value}
        onChange={handleChange}
        sx={{
          "& .MuiOutlinedInput-notchedOutline": {
            border: "none", // Supprime la bordure du TextField
          },
        }}
      />
    </div>
  );
}
